import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.CompleteSetupPage.Content', {
    title: 'Complete your setup from desktop',
    listItem1:
        'Click the button below to get a link. We can send it right now or tomorrow at 10AM (your time zone).{br}{br}',
    listItem2: 'Open the link on your desktop.',
    description: 'You will be able to use our desktop or mobile app when the setup is complete.',
    buttonSendNow: 'Send link to email now',
    buttonSendTomorrow: 'Send link tomorrow',
    toastSendNow: 'The link has been sent to your email',
    toastSendTomorrow: 'We will send the link to your email tomorrow at 10AM',
});
